/** English plan marketing metadata (audience + CTA labels only). */
export const PLAN_MARKETING = {
  free: {
    audience: 'For beginners exploring market moves — at no cost.',
    popular: false,
    ctaLabel: 'Get started free',
  },
  core: {
    audience: 'For active traders with 10 tickers and daily market focus.',
    popular: false,
    ctaLabel: 'Choose Core',
  },
  pro: {
    audience: 'For traders who need full analytics depth and AI Brain.',
    popular: true,
    ctaLabel: 'Choose Pro',
  },
  terminal: {
    audience: 'For power users, teams, and professional workflows.',
    popular: false,
    ctaLabel: 'Choose Terminal',
  },
};

export function getPlanMarketing(tier) {
  return PLAN_MARKETING[tier] ?? { audience: '', popular: false, ctaLabel: 'Choose plan' };
}
